import { GRANTED_AUTHORITIES } from 'constants/endpoints';
import { http } from 'api/apiConfig';
export const fetchGrantedAuthorities = async () => {
    const { data, status } = await http.get(GRANTED_AUTHORITIES);
    if (status !== 200) {
        throw new Error('Failed to fetch granted authorities');
    }
    return data;
};
